<div class="layer-opacity symbol-editor">
    <hr style="margin:1.5rem 0"/>
    <div class="legendWideControlGroup">
        <label class="left">Layer Opacity:</label> 
        <span *ngIf="!showBrightnessText" class="zero-hundred">(0 is transparent, 100 is opaque)</span>
        <div class="grid-container right" style="max-width:800px;">
            <div class="column-10 right" style="padding:0px;">
                <div class="column-2 right" style="padding:0px; margin-left: 20px;">
                    <input class="form-control" type="number" [(ngModel)]="opacity" max="100" min="0" step="1" />
                </div>
                <div class="column-7 right" style="padding:0px">
                    <kendo-slider class="right" [(ngModel)]="opacity" [tickPlacement]="'none'" [min]="0" [max]="100" [showButtons]="false" style="margin-top: 7px;"></kendo-slider>
                </div>
            </div>
        </div>
    </div>
</div>
